import { useCallback, useEffect, useState } from 'react'

import { useBlocker } from 'react-router-dom'
import { setConfirmedNavigation } from 'store/StructuralContext/structuralSlice'
import { useDispatch } from 'store/store'

export function useNavPrompt(when: boolean, exception?: boolean) {
  const dispatch = useDispatch()
  const blocker = useBlocker(useCallback(() => when, [when]))
  const [showPrompt, setShowPrompt] = useState(false)

  const cancelNavigation = useCallback(() => {
    if (blocker.state === 'blocked') {
      blocker.reset()
    }
    setShowPrompt(false)
  }, [blocker])

  const confirmNavigation = useCallback(() => {
    if (blocker.state === 'blocked') {
      blocker.proceed()
    }
    setShowPrompt(false)
  }, [blocker])

  // Show modal when a transition is blocked and condition is true
  useEffect(() => {
    if (blocker.state === 'blocked' && when) {
      if (exception) {
        blocker.proceed()
        // Reset confirmed navigation after ignoring the previous block
        dispatch(setConfirmedNavigation(false))
      } else {
        setShowPrompt(true)
      }
    }
  }, [blocker.state, when, exception])

  // Prevent browser unload/refresh
  useEffect(() => {
    if (!when) return

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault()
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [when])

  return {
    cancelNavigation,
    confirmNavigation,
    showPrompt,
  }
}
